import { Scissors } from 'lucide-react';

// Password rules — kept in sync with backend app/utils/validators.py::validate_password.
const RULES = [
  { label: 'At least 8 characters', test: (p) => p.length >= 8 },
  { label: 'One uppercase letter', test: (p) => /[A-Z]/.test(p) },
  { label: 'One lowercase letter', test: (p) => /[a-z]/.test(p) },
  { label: 'One number', test: (p) => /\d/.test(p) },
  { label: 'One symbol', test: (p) => /[^A-Za-z0-9]/.test(p) },
];

export function isPasswordStrong(password = '') {
  return RULES.every((r) => r.test(password));
}

// Confirm-password row: red scissor + "must match" until the two fields agree,
// then a gold snip-flash "Passwords match". Renders once the confirm field has input.
export function PasswordMatch({ password = '', confirm = '' }) {
  if (!confirm) return null;
  const match = password === confirm;
  return (
    <div className="mt-2 flex items-center gap-2 text-xs" data-testid="password-match">
      <Scissors
        className={`h-4 w-4 shrink-0 transition-colors duration-300 ${
          match ? 'text-primary onda-scissor-flash' : 'text-red-500'
        }`}
        aria-label={match ? 'passwords match' : 'passwords do not match'}
      />
      <span className={match ? 'text-primary' : 'text-muted-foreground'}>
        {match ? 'Passwords match' : 'Passwords must match'}
      </span>
    </div>
  );
}

// Live checklist under a password field. Each rule shows a RED scissor until met,
// then flips to Onda gold; when every rule passes the whole row does the gold
// "snip flash". Renders only once typing starts.
export default function PasswordRequirements({ password = '' }) {
  if (!password) return null;
  const allMet = isPasswordStrong(password);
  return (
    <ul className="mt-2 space-y-1" data-testid="password-requirements">
      {RULES.map((r) => {
        const ok = r.test(password);
        return (
          <li key={r.label} className="flex items-center gap-2 text-xs">
            <Scissors
              className={`h-4 w-4 shrink-0 transition-colors duration-300 ${
                ok
                  ? `text-primary ${allMet ? 'onda-scissor-flash' : ''}`
                  : 'text-red-500'
              }`}
              aria-label={ok ? 'met' : 'not met'}
            />
            <span className={ok ? 'text-primary' : 'text-muted-foreground'}>{r.label}</span>
          </li>
        );
      })}
    </ul>
  );
}
